export default __webpack_public_path__ + "static/media/lady-right.f90cd70e.png";